import _ from 'lodash'
import { post } from '~/plugins/nikan-api'

let requiredOptions = {
  transport: {
    read: {
      name: 'read'
    },
    modify: {
      name: 'modify'
    }
  }
}
let defaultOptions = {
  fields: [],
  sorts: [],
  filters: [],
  transport: {
    read: {
      enabled: true,
      endpoint: null
    },
    modify: {
      enabled: false,
      endpoint: null
    }
  },
  events: {
    sending: (transport, model) => (model),
    receiving: (transport, result) => (result)
  }
}

let validator = (options) => {
  if (options == null) {
    throw new Error('Unable to load options, it seems you didn\'t configure the datasource.')
  }

  let validateTransport = transport => {
    if (!transport.enabled) {
      return true
    }

    if (!transport.endpoint || !transport.endpoint.address) {
      return false
    }

    return true
  }

  validateTransport(options.transport.read)
  validateTransport(options.transport.modify)
}

let dataSource = (options) => {
  validator(options)
  return {
    read: model => {
      model = _.merge({}, {
        fields: options.fields,
        sorts: options.sorts,
        filters: options.filters
      }, model)

      let ready = options.events.sending(options.transport.read, model)
      ready = ready || model

      let endpoint = options.transport.read.endpoint
      endpoint = _.isFunction(endpoint) ? endpoint() : endpoint

      if (endpoint == null) {
        return Promise.reject(new Error('Invalid endpoint'))
      }

      return post(endpoint, ready)
        .then(result => options.events.receiving(options.transport.read, result))
    },
    modify: data => {
      let ready = options.events.sending(options.transport.modify, data)
      ready = ready || data || {}

      let endpoint = options.transport.read.endpoint
      endpoint = _.isFunction(endpoint) ? endpoint() : endpoint

      if (endpoint == null) {
        return Promise.reject(new Error('Invalid endpoint'))
      }

      return post(endpoint, ready)
        .then(result => options.events.receiving(options.transport.modify, result))
    }
  }
}

export default {
  configure: (options) => {
    options = _.merge({}, defaultOptions, options, requiredOptions)
    return dataSource(options)
  }
}
